














import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import { RouteConfig } from 'vue-router';
import { routes } from '../router';
import { store, Getters } from '../store';
import DialogContent from '@/components/DialogContent.vue';
import { IMenuItem } from '@/components/Menu.vue';
import { UserType } from '../modules/user';

// tslint:disable-next-line:no-empty-interface
interface IDashboardItem extends IMenuItem
{
}

@Component<Dashboard>({
})
export default class Dashboard extends Vue
{
  private get isLoggedIn(): typeof store[Getters.IS_LOGGED_IN]
  {
    return store[Getters.IS_LOGGED_IN];
  }

  public get items(): IDashboardItem[]
  {
    return routes
      .filter(this.__filterRoute, this)
      .map(this.__createDashboardItem, this);
  }

  private __filterRoute(route: RouteConfig): boolean
  {
    const meta = route.meta;
    if (meta && (meta.hideDashboard === true || meta.noModule === true))
    {
      return false;
    }

    if (!this.isLoggedIn && (!meta || meta.anonymous !== true))
    {
      return false;
    }

    const currentUserLogin = store[Getters.CURRENT_USER_LOGIN];
    if (meta && meta.userType && currentUserLogin)
    {
      const currentUserType = currentUserLogin.userType;
      if (!this.$_.castArray(meta.userType).some(ut => ut === currentUserType))
      {
        return false;
      }

      if (currentUserType === UserType.OFFICE_WORKER && meta.userPermission) {
        if (!this.$_.castArray(meta.userPermission).some(up => currentUserLogin.userPermissions.some(upUser => up === upUser)))
        {
          return false;
        }
      }
    }

    return true;
  }

  private __createDashboardItem(route: RouteConfig): IDashboardItem
  {
    const meta = route.meta || {};

    const name = meta.module || meta.name || route.name;

    return {
      route: this.$router.resolve(route).href,
      title: this.$root.$t(meta.title || `module.${name}.title`).toString(),
      icon: meta.icon === false ? null : (meta.icon || name ? `$vuetify.icons.${(meta.icon || name).replace(/\./g, '_')}` : null),
    };
  }
}
